import { useContext, useState } from 'react';
import { Link } from 'react-router-dom';
import { Category } from '../../../types/catalog';
import { CategoriesContext } from '../../../App';
import Portal from '../../elements/portal';
import Search from './elements/search';

const menuRootSelector = 'body > .wrapper > .burger-menu';
const menuSelector = menuRootSelector + ' .burger-menu__cont';
const menuRoot = document.querySelector(menuRootSelector);
const closeMenu = () => {
    if (!menuRoot) {
        return;
    }
    menuRoot.classList.remove('active');
    menuRoot.classList.add('hidden');
};
const CategoryItem = ({ slug, name, url, children }: Category) => {
    const [isOpen, setIsOpen] = useState(false);
    return (
        <li key={slug} className={'catalog-menu__item item' + (isOpen ? ' active' : '')}>
            <div className={'tabs__item head' + (isOpen ? ' active' : '')} onClick={() => setIsOpen(!isOpen)}>
                <Link className="tabs__txt link" to={url} onClick={closeMenu}>
                    {name}
                </Link>
                <svg
                    className="icon"
                    width="12"
                    height="18"
                    viewBox="0 0 12 18"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path d="M10 16.37L2 9l8-7.369" stroke="#000" strokeWidth="2" strokeLinecap="square" />
                </svg>
            </div>
            <div className={'catalog-menu-inner content' + (isOpen ? '' : ' hidden collapsed')}>
                <ul className="catalog-menu-inner__list">
                    {children?.map(({ url, name, slug }) => (
                        <li key={slug} className="catalog-menu-inner__item" onClick={closeMenu}>
                            <div className="head">
                                <Link className="link" to={url}>
                                    {name}
                                </Link>
                            </div>
                        </li>
                    ))}
                </ul>
            </div>
        </li>
    );
};

function NewItkMobileMenu() {
    const { categories } = useContext(CategoriesContext);

    return (
        <Portal rootSelector={menuSelector}>
            <Search />
            <ul className="catalog-menu tabs">
                {categories[0]?.children?.map((cat) => (
                    <CategoryItem key={cat.slug} {...cat} />
                ))}
            </ul>
        </Portal>
    );
}

export default NewItkMobileMenu;
